/**
 * Component: Toggle Links
 * Description:
 *
 * Usage:
 *   - Automatically initialises on page load.
 *
 * Notes:
 */

export function toggleLinks(elements) {
    if (!elements || !elements.length) return;

    const toggleLinks = Array.from(elements);
    const activeClass = 'toggle-link__target--visible';

    function closeAllDropdowns() {
        toggleLinks.forEach((link) => {
            const targetId = link.getAttribute('aria-controls');
            const target = document.getElementById(targetId);

            if (!target) return;

            target.classList.remove(activeClass);
            link.setAttribute('aria-expanded', 'false');
            document.body.classList.remove('has-tint')
        });
    }

    function toggleDropdown(event) {
        event.preventDefault();

        const link = event.currentTarget;
        const targetId = link.getAttribute('aria-controls');
        const target = document.getElementById(targetId);

        if (!target) return;

        const isExpanded = link.getAttribute('aria-expanded') === 'true';

        // Always close everything first
        closeAllDropdowns();

        // If it was previously closed, open it
        if (!isExpanded) {
            link.setAttribute('aria-expanded', 'true');
            target.classList.add(activeClass);
            target.focus();

            if (link.hasAttribute('data-body-tint')) {
                document.body.classList.add('has-tint')
            }
        }
    }

    toggleLinks.forEach((link) => {
        link.addEventListener('click', toggleDropdown);
    });

    document.addEventListener('click', (event) => {
        const clickedInside = toggleLinks.some((link) => {
            const target = document.getElementById(link.getAttribute('aria-controls'));
            return link.contains(event.target) || target?.contains(event.target);
        });

        if (!clickedInside) {
            closeAllDropdowns();
        }
    });
}